import script from "./Institution.vue?vue&type=script&setup=true&lang=js"
export * from "./Institution.vue?vue&type=script&setup=true&lang=js"

import "./Institution.vue?vue&type=style&index=0&id=4d930de3&lang=css"

const __exports__ = script;

export default __exports__